/* eslint-disable no-restricted-globals */
/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable max-len */
/* eslint-disable no-alert */
/* eslint-disable no-nested-ternary */
import SelectInput from '@brands/Components/Inputs/SelectInput/SelectInput';
import PatientIntakeNavigation from '@brands/Components/PatientIntakeNavigation/PatientIntakeNavigation';
import { UploadedFile } from '@brands/Dashboard/MyProfile/Patient/utils/utilsFunctions';
import useRoleNavigate from '@brands/hooks/useRoleNavigate';
import useSubscribe, { Subscriber } from '@brands/hooks/useSubscribe';
import { setUserWebState } from '@brands/services/auth/setUserWebState';
import { CaseType } from '@brands/services/cases/types/ICase';
import { Pricings } from '@brands/services/identity/getPricings';
import { selectAuth } from '@brands/store/selectors/auth';
import { selectOrganizationPrices } from '@brands/store/selectors/organizationPrices';
import { selectPatientForm } from '@brands/store/selectors/patientForm';
import { selectPatient } from '@brands/store/selectors/selectedPatient';
import { setForm } from '@brands/store/slices/patientFormSlice';
import store from '@brands/store/store';
import { selectCommonCustomStylesSlim } from '@brands/Utils/customStyles';
import { displayErrorDetails } from '@brands/Utils/displayError';
import { needsPayment } from '@brands/Utils/needsPayment';
import { isPermissionDenied } from '@brands/Utils';
import {
  getPatientReviewProfileRoleSegment,
  getStaffReviewProfileBasePath,
  isStaffCaseCreationRole,
} from '@brands/Utils/reviewProfileBasePath';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import CancelIcon from '@mui/icons-material/Cancel';
import { Button, CircularProgress } from '@mui/material';
import Cookies from 'js-cookie';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import QRCode from 'react-qr-code';

import Container from '../../../../Components/Container/Container';
import { useAppDispatch, useAppSelector } from '../../../../hooks/useReduxHook';
import useWindowSize from '../../../../hooks/useWindowSize';
import MobileHandoffModal from './Components/MobileHandoffModal';
import styles from './styles.module.scss';
import { uploadIntakeImage } from '@brands/Utils/uploadIntakeImage';
import { clearPreviewCache } from '@brands/Utils/mediaPreviewCache';
import { UploadedFileImage } from '@brands/Components/UploadedFileImage/UploadedFileImage';

type Option = {
  value: any;
  label: string;
};

const ImageUploadWeb = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const roleNavigate = useRoleNavigate();
  const screenSize = useWindowSize();
  const isMobile = screenSize.width < 768;
  const { state } = useLocation();
  const { userInfo } = useAppSelector(selectAuth);
  const { currentOrganizationPrices } = useAppSelector(selectOrganizationPrices);
  const [useintraoralCamera, setUseIntraoralCamera] = useState(false);
  const [displayMobileHandOffModal, setDisplayMobileHandOffModal] = useState(false);
  const { values, isFromSmileScanReport } = useAppSelector(selectPatientForm);
  const { selectedPatient: currentPatient } = useAppSelector(selectPatient);
  const [cameraDevices, setCameraDevices] = useState<MediaDeviceInfo[]>([]);
  // selectedDeviceId is only ever set by the user picking a camera from the dropdown - it
  // stays null for the initial/default device so switching cameras doesn't retrigger itself.
  const [selectedDeviceId, setSelectedDeviceId] = useState<string | null>(null);
  const [activeDeviceId, setActiveDeviceId] = useState<string | null>(null);
  const [capturedImages, setCapturedImages] = useState<UploadedFile[]>([]);
  const [capturing, setCapturing] = useState(false);
  const [qrCodeImageUrl, setQrCodeImageUrl] = useState<string | null>(null);
  // Initialize synchronously from the JWT cookie so the QR renders on the
  // first paint — the receiver (PrivateRoutes) authenticates from the URL's
  // ?auth=<JWT> alone and re-fetches its own state, so we don't need the
  // background setUserWebState call to complete before we show the code.
  // Inlined (rather than calling appendStateToUrl) because that helper is
  // defined further down the function body and would be in the TDZ here.
  const [qrUrl, setQrUrl] = useState<string | null>(() => {
    const initialJwt = Cookies.get('jwtToken');
    if (!initialJwt) return null;
    const url = new URL(window.location.href);
    url.searchParams.set('auth', encodeURIComponent(initialJwt));
    return url.toString();
  });
  const searchParams = new URLSearchParams(location.search);
  const routeCaseType = searchParams.get('case_type');
  const caseType: string = !routeCaseType
    ? (values.find((item) => item.form_question_id === 20)?.value.caseType as string)
    : routeCaseType;
  const currentOrganizationPrice = currentOrganizationPrices?.find((currentPrice: Pricings) =>
    currentPrice.case_types.includes(caseType as string),
  );
  const videoRef = useRef<HTMLVideoElement>(null);
  const captureButtonRef = useRef<HTMLButtonElement>(null);
  const capturingRef = useRef(false);
  const imagesValue = values.find((item) => item.form_question_id === 17)?.value.images as UploadedFile[];
  const shouldShowButton = useintraoralCamera || (caseType !== 'one_report' && caseType !== 'second_opinion');
  const formCaseType = values.find((item) => item.form_question_id === 20)?.value.caseType as string;
  // Photos are optional here, so Skip is the only way forward even when photos are already attached
  // (a linked case arrives with the previous case's photos); "Upload photos manually" still shows them.
  const canSkipPhotos =
    formCaseType !== CaseType.one_report && formCaseType !== CaseType.second_opinion && !isFromSmileScanReport;

  const subscriber: Subscriber = useMemo(
    () => ({
      onMessage: (message: Record<string, any>) => {
        if (['mobile_handoff'].includes(message.command)) {
          setDisplayMobileHandOffModal(true);
        } else if (['mobile_case_creation_complete'].includes(message.command)) {
          setDisplayMobileHandOffModal(false);
          goToDashboard();
        }
      },
      commands: ['mobile_handoff', 'mobile_case_creation_complete'],
    }),
    [setDisplayMobileHandOffModal],
  );
  const { subscribe, unsubscribe } = useSubscribe();

  useEffect(() => {
    const subscriptionId = subscribe(subscriber);

    return () => unsubscribe(subscriptionId);
  }, [subscribe, unsubscribe, subscriber]);

  const appendStateToUrl = (jwtToken: string): string => {
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);

    // Set the 'auth' parameter with the JWT token
    url.searchParams.set('auth', encodeURIComponent(jwtToken));

    return url.toString();
  };

  const goToDashboard = useCallback(() => {
    const patientId = (state as { patientId?: number } | null)?.patientId;
    if (isStaffCaseCreationRole(userInfo.role.name) && patientId != null) {
      navigate(
        `${getStaffReviewProfileBasePath(userInfo.role.name)}/${getPatientReviewProfileRoleSegment(
          currentPatient,
        )}/${patientId}`,
      );
    } else {
      roleNavigate('/dashboard');
    }
  }, [userInfo.role.name, navigate, roleNavigate, state, currentPatient]);

  async function ensureCameraPermission(): Promise<boolean> {
    // Only check the Permissions API state here - don't open a getUserMedia stream just to
    // close it again. The camera-preview effect below is the single place that actually
    // acquires the stream; opening one here too raced with it and intermittently left the
    // device busy (NotReadableError), so the preview never appeared. If permission hasn't
    // been decided yet, the native browser prompt still appears when that effect runs.
    if (await isPermissionDenied('camera')) {
      alert('Camera access is blocked. Please enable it in your browser settings.');
      return false;
    }
    return true;
  }

  useEffect(() => {
    // Sync handoff state to the server in the background. The QR was
    // already rendered synchronously via the useState initializer above;
    // this POST only exists so the mobile receiver's PrivateRoutes can
    // rehydrate the in-flight intake form. If the user scans before this
    // completes, the receiver retries briefly. The intentionally tiny
    // payload (no `auth`, no full organization, no pricings) keeps this
    // call short — the receiver re-fetches anything heavy on its own.
    const syncStateInBackground = async (): Promise<void> => {
      const reduxState = store.getState();
      const patientStateMap = reduxState.currentPatientState;
      const authUserId = reduxState?.auth?.userInfo?.id || 0;

      const selectedState = {
        patientForm: reduxState.patientForm,
        selectedPatient: reduxState.selectedPatient.selectedPatient,
        pageState: reduxState.pageState,
        organization_id: reduxState.organization.currentOrganization?.id,
        refreshToken: Cookies.get('refreshToken'),
        jwtTokenExpire: Cookies.get('jwtTokenExpire'),
        patientState: authUserId in patientStateMap ? { [authUserId]: patientStateMap[authUserId] } : {},
        // Without this, completing a linked case's intake via the QR handoff
        // loses which case is being completed (and its needs-payment/prior
        // clinical-data context) the moment the phone rehydrates — the
        // desktop tab's linkedCase slice never reaches it otherwise.
        linkedCase: reduxState.linkedCase,
      };

      try {
        await setUserWebState(selectedState);
      } catch (error: unknown) {
        try {
          displayErrorDetails(error);
        } catch {
          // swallow — we already showed the QR, this is best-effort
        }
      }
    };
    void syncStateInBackground();
  }, []);

  const onBack = (): void => {
    if (useintraoralCamera) {
      const videoElement = document.querySelector('video');
      const stream = videoElement?.srcObject as MediaStream | null;

      if (stream) {
        stream.getTracks().forEach((track) => track.stop());
      }
      setUseIntraoralCamera(false);
    } else {
      dispatch(setForm([...values!]));
      navigate(-1);
    }
  };

  // Single point of getUserMedia acquisition for the preview: opens the requested device once,
  // feeds it straight to the <video>, then enumerates devices off that same active stream (labels
  // are only available once a stream has been granted). Re-running this to just refresh the device
  // list - as the previous open/enumerate/stop-then-reopen version did - stopped and immediately
  // reacquired the same device, which intermittently threw NotReadableError and left the preview blank.
  useEffect(() => {
    if (!useintraoralCamera) return;

    let stream: MediaStream | null = null;

    const startVideoStream = async (): Promise<void> => {
      try {
        stream = await navigator.mediaDevices.getUserMedia({
          video: selectedDeviceId ? { deviceId: { exact: selectedDeviceId } } : true,
        });
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
          videoRef.current.play().catch((err) => console.error('Error playing video:', err));
        }
        captureButtonRef.current?.focus();

        const devices = await navigator.mediaDevices.enumerateDevices();
        setCameraDevices(devices.filter((d) => d.kind === 'videoinput'));
        setActiveDeviceId(stream.getVideoTracks()[0]?.getSettings().deviceId ?? null);
      } catch (err) {
        console.error('Error accessing camera:', err);
        setCameraDevices([]);
        setActiveDeviceId(null);
      }
    };

    startVideoStream();

    return () => {
      stream?.getTracks().forEach((track) => track.stop());
      if (videoRef.current) {
        videoRef.current.srcObject = null;
      }
    };
  }, [useintraoralCamera, selectedDeviceId]);

  // Keep the device list current if a camera is plugged/unplugged mid-session. Only reads
  // enumerateDevices - never opens its own stream, so it can't race with the effect above.
  useEffect(() => {
    if (!useintraoralCamera) return;

    const refreshDeviceList = async (): Promise<void> => {
      const devices = await navigator.mediaDevices.enumerateDevices();
      setCameraDevices(devices.filter((d) => d.kind === 'videoinput'));
    };

    navigator.mediaDevices.addEventListener('devicechange', refreshDeviceList);
    return () => navigator.mediaDevices.removeEventListener('devicechange', refreshDeviceList);
  }, [useintraoralCamera]);

  const movetoNextPage = (): void => {
    const existingAnswer = values!.find((item) => item.form_question_id === 17);
    const existingImages = (existingAnswer?.value?.images ?? []) as UploadedFile[];

    const allImages = [...existingImages, ...capturedImages];

    const filteredPayload = values!.filter((item) => item.form_question_id !== 17);

    filteredPayload.push({
      form_question_id: 17,
      value: { images: allImages },
    });

    dispatch(setForm(filteredPayload));

    const videoElement = document.querySelector('video');
    const stream = videoElement?.srcObject as MediaStream | null;

    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
    }
    setUseIntraoralCamera(false);

    roleNavigate('/upload-image-flow');
  };

  const captureImage = async (): Promise<void> => {
    if (capturingRef.current || !videoRef.current) return;
    capturingRef.current = true;
    setCapturing(true);
    try {
      const canvas = document.createElement('canvas');
      canvas.width = videoRef.current.videoWidth;
      canvas.height = videoRef.current.videoHeight;
      const ctx = canvas.getContext('2d');
      if (!ctx) return;
      ctx.drawImage(videoRef.current, 0, 0, canvas.width, canvas.height);
      const blob: Blob | null = await new Promise((resolve) => canvas.toBlob(resolve, 'image/png'));
      if (!blob) return;
      const filename = `Capture-${capturedImages.length + 1}.png`;
      const file = new File([blob], filename, { type: 'image/png' });
      const uploaded = await uploadIntakeImage(file, userInfo?.role?.name);
      setCapturedImages((prev) => [...prev, uploaded]);
    } catch (error: unknown) {
      displayErrorDetails(error);
    } finally {
      capturingRef.current = false;
      setCapturing(false);
    }
  };

  const deleteImage = (index: number): void => {
    setCapturedImages((prev) => {
      const removed = prev[index];
      if (removed?.media_id) clearPreviewCache(removed.media_id);
      return prev.filter((_, i) => i !== index);
    });
  };

  const cameraOptions: Option[] = cameraDevices.map((device) => ({
    value: device.deviceId,
    label: device.label || 'Camera',
  }));

  return (
    <Container
      isVisibleOnMobile
      containerStyle={{
        justifyContent: screenSize.width >= 564 ? 'center' : 'start',
        overflow: 'hidden',
      }}
      childrenStyle={{ zIndex: '2', paddingTop: screenSize.width > 768 ? '40px' : '16px' }}
      isSidenavVisible={false}
      isIntakeProcess
    >
      <div className={styles.uploadImageContainer}>
        <div className={styles.patientSelectTopDivContainer}>
          <PatientIntakeNavigation progress={68} />
        </div>
        {!useintraoralCamera ? (
          <div className={styles.uploadImageContainerDiv}>
            <div className={styles.uploadImageContainerDivFirst}>
              <div className={`fs-unmask ${styles.uploadImageContainerDivFirstLeft}`}>
                <span
                  className={`fs-unmask ${styles.uploadImageContainerDivFirstLeftHeader}`}
                  data-testid="image-upload-header"
                >
                  Help us prepare for your virtual appointment
                </span>
                <span className={`fs-unmask ${styles.getReady}`}>
                  Get ready for your appointment by sharing clear photos of your mouth! These help your dentist:
                </span>
                <ul className={`fs-unmask ${styles.bolletList}`}>
                  <li>Save time during your visit.</li>
                  <li>Better understand your needs.</li>
                  <li>Create a personalized care plan.</li>
                </ul>
                <span className={`fs-unmask ${styles.itsEasy}`}>It’s easy!</span>
                <ul className={`fs-unmask ${styles.numberedList}`}>
                  <li>Use your smartphone to take clear, well-lit photos of your teeth, gums, and concerns.</li>
                  <li>Upload securely through our app.</li>
                </ul>
                <span className={`fs-unmask ${styles.final}`}>
                  Your photos are private and used only for this appointment. For a smoother start, scan the QR code to
                  begin.
                  <span className={`fs-unmask ${styles.finalLink}`} onClick={() => roleNavigate('/qr-learn-more')}>
                    {' '}
                    Learn more about QR codes.
                  </span>
                </span>
              </div>
              <div className={`fs-unmask ${styles.uploadImageContainerDivRight}`}>
                <div className={styles.uploadImageContainerDivFirstRight}>
                  <div className={styles.uploadImageContainerDivFirstRightContainer}>
                    <div className="fs-exclude">
                      {qrUrl ? (
                        <QRCode
                          className={`fs-exclude ${styles.qrCodeImage}`}
                          value={qrUrl}
                          size={200}
                          title="Upload photos QR Code"
                        />
                      ) : (
                        <CircularProgress data-testid="image-upload-generate-qr" />
                      )}
                    </div>
                  </div>
                </div>
                <Button
                  variant="text"
                  className={`fs-unmask ${styles.uploadPhotosManually}`}
                  onClick={() => roleNavigate('/upload-image-flow')}
                  data-testid="image-upload-photos-manually"
                >
                  Upload photos manually
                </Button>
              </div>
            </div>
            <div className={styles.uploadImageContainerDivSecond}>
              {!isMobile && isStaffCaseCreationRole(userInfo.role.name) && (
                <div className={`fs-unmask ${styles.uploadImageIntraoralCamera}`}>
                  <span>
                    If you’re a provider using an intraoral camera to capture these images,{' '}
                    <a
                      onClick={async () => {
                        const granted = await ensureCameraPermission();
                        if (granted) {
                          setUseIntraoralCamera(true);
                        }
                      }}
                    >
                      click here.
                    </a>
                  </span>
                </div>
              )}
            </div>
            <div className={styles.uploadImageContainerDivFooter}>
              <Button onClick={onBack} data-testid="image-upload-photos-back" className={`fs-unmask ${styles.backBtn}`}>
                <ArrowBackIosIcon />
                Back
              </Button>
              {canSkipPhotos && (
                <div className={`fs-unmask ${styles.btnContainer}`}>
                  <Button
                    variant="contained"
                    type="button"
                    className="fs-unmask"
                    onClick={() =>
                      roleNavigate(
                        formCaseType === CaseType.clinical_enablement
                          ? '/clinical-data'
                          : needsPayment(currentOrganizationPrice)
                          ? '/payment-information'
                          : '/confirm-payment',
                      )
                    }
                    data-testid="image-upload-photos-skip"
                  >
                    Skip
                  </Button>
                </div>
              )}
              {!canSkipPhotos && imagesValue && imagesValue.length > 0 && (
                <div className={`fs-unmask ${styles.btnContainer}`}>
                  <Button
                    variant="contained"
                    type="button"
                    onClick={() => {
                      roleNavigate('/upload-image-flow');
                    }}
                    className="fs-unmask"
                    data-testid="image-upload-photos-has-images-next"
                  >
                    Next
                  </Button>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className={`fs-unmask ${styles.previewSection}`}>
            <video ref={videoRef} autoPlay playsInline muted />
            <div className={`fs-unmask ${styles.imageStrip}`}>
              {capturedImages.map((img, i) => (
                <div className={`fs-unmask ${styles.imageWrapper}`} key={img.media_id ?? `${img.name}-${i}`}>
                  <UploadedFileImage file={img} userRole={userInfo?.role?.name} alt={`Capture ${i + 1}`} />
                  <CancelIcon className={`fs-unmask ${styles.delete}`} onClick={() => deleteImage(i)} />
                </div>
              ))}
            </div>
            <button
              ref={captureButtonRef}
              className={`fs-unmask ${styles.captureButton}`}
              onClick={() => void captureImage()}
              disabled={capturing}
              type="button"
            >
              <CameraAltIcon />
            </button>
            <div className={`fs-unmask ${styles.cameraSelector}`}>
              <SelectInput
                name="camera"
                options={cameraOptions}
                style={selectCommonCustomStylesSlim}
                containerClass={styles.inputWrapper}
                selectorClass={styles.selector}
                selectedValue={cameraOptions.find((opt) => opt.value === (selectedDeviceId ?? activeDeviceId))}
                onChange={(value) => {
                  setSelectedDeviceId(value?.value);
                }}
                isClearable={false}
              />
            </div>
            <div className={styles.uploadImageContainerDivFooter} style={{ width: 'fit-content', margin: '40px 0' }}>
              <Button onClick={onBack} data-testid="image-upload-photos-back" className={`fs-unmask ${styles.backBtn}`}>
                <ArrowBackIosIcon />
                Back
              </Button>
              {shouldShowButton && (
                <div className={`fs-unmask ${styles.btnContainer}`}>
                  <Button
                    variant="contained"
                    type="button"
                    className={`fs-unmask ${styles.selectFooterNext}`}
                    onClick={() => {
                      if (!useintraoralCamera) {
                        roleNavigate(
                          needsPayment(currentOrganizationPrice) ? '/payment-information' : '/confirm-payment',
                        );
                      } else {
                        movetoNextPage();
                      }
                    }}
                    disabled={useintraoralCamera && capturedImages.length === 0}
                    data-testid="image-upload-photos-next"
                  >
                    {useintraoralCamera ? 'Next' : 'Skip'}
                  </Button>
                </div>
              )}
            </div>
          </div>
        )}

        {displayMobileHandOffModal && <MobileHandoffModal />}
      </div>
    </Container>
  );
};
export default ImageUploadWeb;
